import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class OrganizationService {
    static getAvailableOrganizations(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayOrganization'),
            'getAllOrganizations',
            [],
            additionalHeaders
        );
    }

    static getProducerCodeForOrganization(
        organization,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayOrganization'),
            'getProducerCodeForOrganization',
            [organization],
            additionalHeaders
        );
    }

        // US26284: PE - Common Quote - New Account - Policyholder Details
        // Display an error message if Account Holder email is the same as any producer in the organization
        static isProducerEmail_TWIA (
            emailAddress, 
            additionalHeaders = {}
        ) {
            return JsonRPCService.send(
                getProxiedServiceUrl('gatewayOrganization'), 
                'isProducerEmail', 
                [emailAddress],
            additionalHeaders
            );
        }
}
